// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__BzEwR","message":"Loader_message__Q9RvR","siren":"Loader_siren__J9kCq","strobe":"Loader_strobe__ss2kT","strobeb":"Loader_strobeb__e4Txp"};